// extracted by mini-css-extract-plugin
module.exports = {"container":"QuizCard_container__vvhuT","text":"QuizCard_text__yQQBy","check-container":"QuizCard_check-container__ts_fM","dashed-circle":"QuizCard_dashed-circle__2uwNN"};